import type { ComponentProps, FC, ReactElement } from "react"

import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { buildCssClassName } from "@/3514/utils"

import { Link } from "../link"
import { ETypographyAlignment, ETypographyColor, ETypographySize, ETypographyWeight, Typography } from "../typography"

type TProps = {
    className?: string
    renderMessage(): Pick<ComponentProps<typeof Typography>, "text">
    renderLink?(): Omit<ComponentProps<typeof Link>, "to" | "children">
}

const Box: FC<TProps> = ({ className, renderMessage, renderLink }: TProps): ReactElement => {
    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    return (
        <div className={buildCssClassName(["flex", "flex-col", "items-center"], { [className]: className })}>
            <Typography
                {...renderMessage()}
                isPretty
                size={ETypographySize.Small}
                color={ETypographyColor.Dark}
                alignment={ETypographyAlignment.Center}
            />

            <Link
                to={`mailto:${productType?.supportEmail}`}
                textSize={ETypographySize.Small}
                textWeight={ETypographyWeight.Default}
                {...renderLink?.()}
            >
                {productType.supportEmail}
            </Link>
        </div>
    )
}

Box.displayName = "CareMailBox"

export { Box as CareMailBox }
